var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDispatched = function SvgDispatched(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dispatched_svg__SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dispatched_svg__cls-1,.dispatched_svg__cls-2{fill:#77acf1}")), /*#__PURE__*/React.createElement("g", {
    id: "dispatched_svg___18._Fast_Delivery",
    "data-name": "18. Fast Delivery"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6h6v5.13a.87.87 0 0 1-.87.87h-4.26a.87.87 0 0 1-.87-.87z",
    className: "dispatched_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 27H13a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3M13 7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Z",
    className: "dispatched_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 23h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2",
    className: "dispatched_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17H5a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2M7 13H3a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2M7 9H1a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2",
    className: "dispatched_svg__cls-1"
  })))));
};
export default SvgDispatched;